import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="min-h-screen bg-[#0d0d0d] flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-9xl md:text-[12rem] font-black text-white/[0.04] select-none pointer-events-none">
        404
      </h1>
      <div className="relative z-10 -mt-16">
        <p
          className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Error
        </p>
        <h1
          className="text-3xl md:text-4xl font-extrabold text-white"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Page Not Found
        </h1>
        <p className="mt-4 text-base text-[#6C7278]" style={{ fontFamily: "'Public Sans', sans-serif" }}>
          The page <code className="text-white/40">{location.pathname}</code> does not exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 bg-[#B8422E] text-white px-7 py-3 text-[13px] font-semibold hover:bg-[#9E3826] transition-colors duration-300 whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
        >
          Back to Home
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </main>
  );
}